import classNames from 'classnames'

interface IProps {
  className?: string
}

export const VertSpacerLg: React.FC<IProps> = ({ className }) => <div className={classNames('pt-5', className)} />
